
import { createSlice } from '@reduxjs/toolkit'

export const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        uid: null,
        email: null,
        name: null,
        pic: null
    },
    reducers: {
        actionUpdateKeyValue: (state: any, action) => {
            // console.log("actionUpdateKeyValue", action)
            const payload: any = action.payload;
            Object.keys(payload).map((key) => {
                state[key] = payload[key];
            })
        }
    },
})

export const selectProfile = (state: any) => state.profile;

// Action creators are generated for each case reducer function
export const { actionUpdateKeyValue } = profileSlice.actions
  
export default profileSlice.reducer;